import React from 'react';
import UserManagement from '../components/UserManagement';
import { useRole } from '../hooks/useRole';

export default function WorkspaceUsers({ embedded = false }) {
  const { clientId } = useRole();
  if (!clientId) return <div style={{ padding: embedded ? 0 : '2rem', color: '#888' }}>Loading workspace...</div>;
  return (
    <div style={embedded ? { boxSizing: 'border-box' } : { padding: '2rem', maxWidth: '1100px', margin: '0 auto', boxSizing: 'border-box' }}>
      {!embedded && <h1 style={{ fontSize: '1.4rem', fontWeight: '500', margin: '0 0 1.5rem', color: '#1A1A1A' }}>Users</h1>}
      <UserManagement clientId={clientId} heading="Team members" subheading="Manage who has access to this workspace" />
    </div>
  );
}
